export type Province =
  | "CA-AB"
  | "CA-BC"
  | "CA-MB"
  | "CA-NB"
  | "CA-NL"
  | "CA-NS"
  | "CA-NT"
  | "CA-NU"
  | "CA-ON"
  | "CA-PE"
  | "CA-QC"
  | "CA-SK"
  | "CA-YT";

export const AllProvinces: Province[] = [
  "CA-AB",
  "CA-BC",
  "CA-MB",
  "CA-NB",
  "CA-NL",
  "CA-NS",
  "CA-ON",
  "CA-PE",
  "CA-QC",
  "CA-SK",
  "CA-NT",
  "CA-YT",
  "CA-NU",
];
